import { render } from "./integrations.vue?vue&type=template&id=f840da9a"
import script from "./integrations.vue?vue&type=script&lang=js"
export * from "./integrations.vue?vue&type=script&lang=js"

import "./integrations.vue?vue&type=style&index=0&id=f840da9a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__